import React, { useState, useRef, useEffect } from "react";
import "./index.scss";
import { Avatar, Box, Button, getColor, Icons, Tooltip, Typography } from "fds";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import utilsCommon from "../../shared/utils/common";
import { Workgroup } from "../../types/workgroup";
import AvatarGroup from "fds/src/components/atom/Avatargroup";
import { t } from "i18next";
interface WorkgroupCardProps {
  row: Workgroup;
  setWorkgroupSettingInfo: (req: {
    x: number;
    y: number;
    id: string;
    workgroupInfo: Workgroup;
  }) => void;
  opacity?: string;
}

const WorkgroupCard: React.FC<WorkgroupCardProps> = ({
  row,
  setWorkgroupSettingInfo,
  opacity,
}) => {
  const navigate = useNavigate();

  return (
    <Box
      classes={"workgroupCard"}
      onContextMenu={(e) => {
        e.preventDefault();
        e.stopPropagation();
        if (row.isValidate !== 0)
          setWorkgroupSettingInfo({
            x: e.pageX - 240,
            y: e.pageY - 61,
            id: row.workgroupId,
            workgroupInfo: row,
          });
      }}
      onClick={(e: any) => {
        e.preventDefault();
        e.stopPropagation();
        navigate(`${process.env.PUBLIC_URL}/workgroup/${row.workgroupId}/home`);
      }}
    >
      {row.isValidate === 0 ? (
        <Tooltip
          classes="workgroupCard-dropdown"
          message={t("workgroup.expired.title")}
        >
          <Button
            btnStyle="table-icon"
            leadingIcon={
              <Icons
                variant="line"
                label="alertCircle"
                stroke={getColor("COLOR_ICON_ERROR")}
              />
            }
          />
        </Tooltip>
      ) : (
        <Button
          btnStyle={"table-icon"}
          size="sm"
          classes="workgroupCard-dropdown"
          onClick={(e) => {
            e.stopPropagation();
            setWorkgroupSettingInfo({
              x: e.pageX - 240,
              y: e.pageY - 61,
              id: row.workgroupId,
              workgroupInfo: row,
            });
          }}
          leadingIcon={<Icons variant="line" label="moreVertical" />}
        />
      )}
      <Box alignItems="center" width="100%">
        <Avatar
          name={row.workgroupName}
          size="40"
          shape="workgroup"
          uniqueCode={row.workgroupId}
          opacity={opacity}
        />
        <Box direction="column" classes={"mg ml-8"} width="calc(100% - 80px)">
          <Box alignItems="center">
            <Tooltip message={row.workgroupName} maxWidth="calc(100% - 20px)">
              <Typography
                type="body2_rg"
                ellipsis
                exactColor={
                  row.isValidate === 0
                    ? getColor("COLOR_TEXT_DISABLED")
                    : undefined
                }
              >
                {row.workgroupName}
              </Typography>
            </Tooltip>

            <Icons
              variant="fill"
              label="star"
              isColored={row.favorite === "Y"}
              size={16}
              classes={classNames("star mg ml-4", {
                "star-isNotFilled": row.favorite === "N",
              })}
              style={{ opacity: opacity }}
            />
          </Box>
          <Typography
            type="body4_rg"
            ellipsis
            exactColor={
              row.isValidate === 0
                ? getColor("COLOR_TEXT_DISABLED")
                : getColor("COLOR_TEXT_SECONDARY")
            }
          >
            {utilsCommon.renderDateFormat(row.updateDate)}
          </Typography>
        </Box>
      </Box>
      <Box classes="mg mt-12">
        <Tooltip
          message={row.members
            .map((item) => item?.userName || item?.userId)
            .join(", ")}
        >
          <AvatarGroup
            visibleLength={8}
            size={"24"}
            opacity={opacity}
            items={utilsCommon.sortMembersToAvatarGroup(
              row?.members,
              row?.managerId
            )}
          />
        </Tooltip>
      </Box>
    </Box>
  );
};
export default WorkgroupCard;
